module.exports = __webpack_public_path__ + "images/93d899f93f0059f07a85d4be3a99ca50.svg";